export default {
      id: "service-presentation-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#service-presentation",
      toString: function () {
        return this.url;
      }
    }